import { useState } from "react"
import { PdfViewerContext } from "./InterceptorContext"

export function PdfViewerProvider({ children }: { children: JSX.Element }) {
  const [pdf, setPdf] = useState<Blob | null>(null)

  return (
    <PdfViewerContext.Provider value={{ pdf, setPdf }}>
      {children}
    </PdfViewerContext.Provider>
  )
}
